export default __webpack_public_path__ + "static/media/india.c30fb6cd.svg";